export const MAX_RECORDING_MS = 60_000;

export type VoiceState =
  | "idle"
  | "starting"
  | "recording"
  | "transcribing"
  | "denied"
  | "error";

export type VoiceInput = {
  available: boolean;
  state: VoiceState;
  elapsedMs: number;
  message?: string;
  transcript?: string;
  start: () => void;
  stop: () => void;
  cancel: () => void;
  clearTranscript: () => void;
};

export type VoiceEngine = "nelly" | "browser";

export const VOICE_ENGINE_LABELS: Record<VoiceEngine, string> = {
  nelly: "Nelly",
  browser: "Browser",
};

export type VoiceControl = VoiceInput & {
  engine: VoiceEngine;
  engines: VoiceEngine[];
  setEngine: (engine: VoiceEngine) => void;
};
